import { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

/**
 * InputModal - Custom prompt modal
 * Replaces native window.prompt()
 */
export default function InputModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    placeholder = 'Escribe aquí...',
    initialValue = '',
    confirmText = 'Aceptar',
    cancelText = 'Cancelar'
}) {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        if (isOpen) {
            setValue(initialValue);
        }
    }, [isOpen, initialValue]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm(value);
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm bg-black/60">
            {/* Overlay */}
            <div className="absolute inset-0" onClick={onClose}></div>

            {/* Modal */}
            <div className="relative bg-[#1a1a3e] rounded-2xl shadow-2xl border border-white/10 w-full max-w-md transform transition-all animate-scale-in">
                <div className="p-6">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-xl font-bold text-white">{title}</h3>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-white transition-colors p-1 hover:bg-white/10 rounded-lg"
                        >
                            <XMarkIcon className="w-6 h-6" />
                        </button>
                    </div>

                    {/* Body */}
                    <form onSubmit={handleSubmit}>
                        {message && <p className="text-gray-400 text-sm mb-4">{message}</p>}

                        <div className="relative">
                            <input
                                autoFocus
                                type="text"
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                                placeholder={placeholder}
                                className="w-full bg-[#0f0f23] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500 transition-all"
                            />
                        </div>

                        {/* Actions */}
                        <div className="flex items-center justify-end gap-3 mt-6">
                            <button
                                type="button"
                                onClick={onClose}
                                className="px-4 py-2 text-gray-400 hover:text-white transition-colors font-medium"
                            >
                                {cancelText}
                            </button>
                            <button
                                type="submit"
                                disabled={!value.trim()}
                                className="px-6 py-2 bg-purple-500 hover:bg-purple-600 disabled:opacity-50 disabled:cursor-not-allowed text-white rounded-xl font-bold shadow-lg shadow-purple-500/20 transition-all"
                            >
                                {confirmText}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
